import cn from "classnames"
import { RenderBardWithComponents } from "components/Wysiwyg"
import Image from "../Image"
import Letter from "../ui/Letter"
import styles from "./BaseHero.module.scss"

const BaseHero = ({
  kicker,
  headline,
  subline,
  subtext,
  image,
  letter: letterObj,
  colors,
  locale,
  isArticle,
  isReference,
  readingTime,
  isFull,
  publishDate,
  cornersRounded = [0, 0, 0, 0],
  showSubtexts = true,
}) => {
  const fillColorPrimary = colors[1].value

  const letter = letterObj?.value?.toLowerCase() || "v"
  const hasImage = Boolean(image)
  const hasLetter = letterObj && letter !== "none"

  return (
    <div
      className={cn(styles.wrapper, {
        [styles.article]: isArticle,
        [styles.isGrid]: hasImage || hasLetter,
        [styles.isFull]: isFull,
        [styles.reference]: isReference,
        [styles.hasImage]: hasImage,
        [styles[`BaseHero--${locale}`]]: locale,
      })}
    >
      {(kicker || headline || subline || text) && (
        <div
          className={cn(styles.textWrapper, {
            [styles.noReadingTime]: !readingTime,
          })}
        >
          <div className={styles.text}>
            <div className={hasImage || hasLetter ? styles.textTop : ""}>
              {kicker && <p className="teaser">{kicker}</p>}
              {headline && (
                <h1
                  className={cn(styles.headline, {
                    "mb-0": !subline && !subtext,
                  })}
                >
                  {headline}
                </h1>
              )}
              {(locale === "digital" || showSubtexts) && (
                <>
                  {subline && <p className={styles.subline}>{subline}</p>}
                  {subtext && (
                    <RenderBardWithComponents
                      content={subtext}
                      prefix="page_"
                      className={styles.subline}
                      buttonClass="button--cta-alt"
                    />
                  )}
                </>
              )}
            </div>

            <div className={styles.publishDateAndReadingTime}>
              {publishDate && <span>{publishDate}</span>}
              {publishDate && readingTime > 0 && "|"}
              {readingTime > 0 && (
                <div className={styles.heroReadTime}>
                  <span>Lesezeit</span>
                  <span>{`${readingTime} ${
                    readingTime === 1 ? "Minute" : "Minuten"
                  }`}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {(hasImage || hasLetter) && (
        <div
          className={cn(styles.imageContainer, {
            [styles.hasLetter]: hasLetter,
          })}
        >
          <div
            className={cn(styles.imageWrapper, {
              [styles.bigRounded]: true,
            })}
          >
            {hasImage && (
              <div
                className={cn(styles.image, {
                  [styles.bigRounded]: true,
                  "rounded-tl-design": cornersRounded[0],
                  "rounded-tr-design": cornersRounded[1],
                  "rounded-br-design": cornersRounded[2],
                  "rounded-bl-design": cornersRounded[3],
                })}
              >
                <div className={styles.imageElement}>
                  <Image
                    src={image.permalink}
                    fill
                    style={{ objectPosition: image.focus_css }}
                    sizes="(max-width: 1023px) 100vw, 50vw"
                    alt={image?.alt}
                  />
                </div>
              </div>
            )}
            {hasLetter && (
              <Letter
                type={letter}
                fill={fillColorPrimary}
                className={
                  letter === "v" ? styles.letterImageV : styles.letterImageL
                }
              />
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default BaseHero
